import { useGetAPI } from '@api/useAPI';
import { LocationOwnersResponse, LocationGroup, AJAXError, APICallProps } from '@types';
import { useCallback } from 'react';

export const useGetLocationGroups = () => {
	const {
		isLoading,
		error,
		callAPI
	} = useGetAPI({ endpoint: '/api/admin/locations/groups' });

	return {
		isLoadingLocationGroups: isLoading,
		getErrorLocationGroups: error as AJAXError,
		callGetLocationGroups: callAPI as (props?: APICallProps) => Promise<{
			data: LocationGroup[] | null;
			error: AJAXError | null;
		}>
	}
}

export const useGetLocationOwners = () => {
	const {
		isLoading,
		data,
		error,
		callAPI
	} = useGetAPI({ endpoint: '/api/admin/locations/owner-search?q={1}', });

	const triggerCallAPI = useCallback((search: string) => {
		callAPI({ routes: [search] });
	}, [callAPI]);

	return {
		loadingLocationOwners: isLoading,
		owners: data as LocationOwnersResponse,
		locationOwnersError: error,
		callGetLocationOwners: triggerCallAPI
	}
}